import ResetTable from './ResetTable';
export default ResetTable;